import { useCallback, useMemo } from 'react'
import { Logger } from '@terros/common'
import { useQueryClient } from '@tanstack/react-query'
import { chatGetKey, chatListKey } from '../keys'

const logger = new Logger('useChatCache')

type Result = {
  clearList: VoidFunction
  removeChat: (sessionId: string) => void
}

export function useChatCache(): Result {
  const queryClient = useQueryClient()

  const clearList = useCallback((): void => {
    logger.verbose('invalidateQueries chatListKey')
    queryClient.invalidateQueries({ queryKey: chatListKey() })
  }, [])

  const removeChat = useCallback((sessionId: string): void => {
    logger.verbose('removing sessionId from cache', sessionId)
    queryClient.removeQueries({ queryKey: chatGetKey(sessionId) })
  }, [])

  return useMemo(
    () => ({
      clearList,
      removeChat,
    }),
    [clearList, removeChat]
  )
}
